<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import AuditTrailSection from 'next/wgpt/AuditTrail/AuditTrailSection.vue';

const props = defineProps({
  automationId: {
    type: Number,
    default: null,
  },
});

const { t } = useI18n();

const auditTrailFilters = computed(() => [
  {
    attributeKey: 'model',
    filterOperator: 'equal_to',
    values: {
      id: 'WgptAutomation',
      name: 'WgptAutomation',
    },
    queryOperator: 'and',
    attributeModel: 'standard',
  },
  {
    attributeKey: 'id',
    filterOperator: 'equal_to',
    values: props.automationId,
    attributeModel: 'standard',
  },
]);
</script>

<template>
  <AuditTrailSection
    v-if="automationId"
    :title="t('WGPT_INTEGRATIONS.ZID.EDITOR.SETTINGS.AUDIT_TRAIL.TITLE')"
    :description="
      t('WGPT_INTEGRATIONS.ZID.EDITOR.SETTINGS.AUDIT_TRAIL.DESCRIPTION')
    "
    :filters="auditTrailFilters"
  />
</template>
